var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M18.64 0a3.35 3.35 0 0 1 3.345 3.346V13.86a3.352 3.352 0 0 1-2.867 3.312v4.335a.478.478 0 0 1-.817.339l-4.639-4.64H3.346A3.35 3.35 0 0 1 0 13.86V3.346A3.35 3.35 0 0 1 3.346 0zm0 .956H3.346a2.392 2.392 0 0 0-2.39 2.39V13.86a2.392 2.392 0 0 0 2.39 2.39H13.86c.127 0 .249.05.339.14l3.963 3.963v-3.625c0-.264.214-.478.478-.478a2.392 2.392 0 0 0 2.39-2.39V3.346a2.392 2.392 0 0 0-2.39-2.39zM10.993 11.47c.79 0 1.433.644 1.433 1.434 0 .79-.643 1.434-1.433 1.434-.791 0-1.434-.643-1.434-1.434 0-.79.643-1.434 1.434-1.434zm.477-8.602a1.436 1.436 0 0 1 1.43 1.536l-.412 4.724a1.504 1.504 0 0 1-3-.008l-.403-4.71a1.436 1.436 0 0 1 1.43-1.543z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWarning);
export default __webpack_public_path__ + "static/media/ic-warning.c432c1bd270959b98019a46e4f862675.svg";
export { ForwardRef as ReactComponent };